import { Optional, SystemSettingsTemplate } from '../../../types/common';
import { PlatformData } from '../../../types/systems';

export const platformsSettingsTemplate: SystemSettingsTemplate<PlatformData> = {
	sections: {
		Categories: {
			mobility: {
				type: 'select',
			},
			subtype: {
				type: 'select',
			},
			sensor_elevation: {
				type: 'slider',
				max_limit: 10,
				step: 1,
				unit: 'm',
			},
			endurance: {
				type: 'slider',
				max_limit: 2880,
				step: 20,
				unit: 'min',
			},
			base_speed: {
				type: 'slider',
				max_limit: 3000,
				step: 50,
				unit: 'km/h',
			},
			dash_speed: {
				type: 'slider',
				max_limit: 3000,
				step: 50,
				unit: 'km/h',
			},
			max_roughness: {
				type: 'slider',
				max_limit: 100,
			},
			rest_period: {
				type: 'slider',
				max_limit: 2880,
				step: 20,
				unit: 'min',
			},
			min_altitude: {
				type: 'slider',
				max_limit: 12000,
				step: 100,
				unit: 'm',
			},
			max_altitude: {
				type: 'slider',
				max_limit: 12000,
				step: 100,
				unit: 'm',
			},
			rcs: {
				type: 'number-input',
				label: 'Radar Cross-Section (dBsm)',
				unit: 'dBsm',
			},
			weight: {
				type: 'dynamic-unit-input',
				label: 'Weight',
				unitType: 'weight',
				unit: 'kg',
				min_limit: 0,
				max_limit: 100000000,
				step: 1,
				precision: 2,
			},
			payload_weight: {
				type: 'dynamic-unit-input',
				label: 'Payload Weight',
				unitType: 'weight',
				unit: 'kg',
				min_limit: 0,
				max_limit: 5000000,
				step: 1,
				precision: 2,
			},
		},
		Confounders: {
			confounders: {
				type: 'static-table',
				columns: { type: 'Type', degradation_percent: 'Degradation (%)' },
				use_archetypes: false,
				editable: false,
			},
		},
		Platform: {
			side: {
				type: 'select',
				data: [
					{ value: '2', label: 'NONE' },
					{ value: '0', label: 'BLUE' },
					{ value: '1', label: 'RED' },
				],
			},
			cost: 'text',
			type_name: 'text',
			specific_name: 'text',
		},
	},
};

export const defaultSettings: Optional<PlatformData, 'id'> = {
	specific_name: 'New platform',
	side: 0,
	cost: '0',
	mobility: '11',
	subtype: 0,
	sensor_elevation: 0,
	endurance: 0,
	base_speed: 0,
	dash_speed: 0,
	max_roughness: 0,
	rest_period: 0,
	min_altitude: 0,
	max_altitude: 0,
	weight: 0,
	payload_weight: 0,
	confounders: [],
	type_name: 'New platform type',
};
